import { useEffect, useRef } from "react";
import { useKeycloakSession } from "./useKeycloakSession";

export function useOnceEffect(effect: () => void | (() => void)) {
  const hasRunOnce = useRef(false);
  const effectRef = useRef(effect);
  const { session } = useKeycloakSession();

  // Always keep the latest effect reference without triggering re-runs.
  effectRef.current = effect;

  useEffect(() => {
    if (!session || hasRunOnce.current) return;

    hasRunOnce.current = true;
    const cleanup = effectRef.current();

    // Return cleanup function if the effect provided one.
    return typeof cleanup === "function" ? cleanup : undefined;
  }, [session]);
}
